(function(){
    document.querySelectorAll('[data-tag-input]').forEach(root=>{
        const list = root.querySelector('.tag-list') || (()=>{ const d=document.createElement('div'); d.className='tag-list'; root.prepend(d); return d; })();
        const input = root.querySelector('.tag-input__field') || (()=>{ const i=document.createElement('input'); i.type='text'; i.className='tag-input__field'; root.appendChild(i); return i; })();
        const hidden = root.querySelector('input[type="hidden"][name]');

        function render(){
            const values = getValues();
            list.innerHTML='';
            values.forEach(v=>{
                const chip = document.createElement('span');
                chip.className='tag-chip';
                chip.innerHTML = `<span>${v}</span><button type="button" class="tag-chip__remove" aria-label="Retirer">✕</button>`;
                chip.querySelector('.tag-chip__remove').addEventListener('click', ()=>{
                    remove(v); render();
                });
                list.appendChild(chip);
            });
            if(hidden) hidden.value = values.join(',');
        }

        function getValues(){
            const raw = hidden?.value || root.getAttribute('data-values') || '';
            return raw ? raw.split(',').map(s=>s.trim()).filter(Boolean) : [];
        }

        function add(v){
            v = (v||'').trim(); if(!v) return;
            const values = getValues();
            if(!values.includes(v)) values.push(v);
            if(hidden) hidden.value = values.join(',');
        }
        function remove(v){
            const values = getValues().filter(x=>x!==v);
            if(hidden) hidden.value = values.join(',');
        }

        input.addEventListener('keydown', (e)=>{
            if(e.key==='Enter' || e.key===',' ){
                e.preventDefault();
                add(input.value); input.value=''; render();
            } else if(e.key==='Backspace' && !input.value){
                const vals = getValues(); const last = vals.pop();
                if(hidden) hidden.value = vals.join(','); render();
                if(last) input.value = last; // édition rapide
            }
        });

        render();
    });
})();
